export default __webpack_public_path__ + "static/media/IconWhiteBrushBaseball.99fae09f.svg";